export const downloads = [
  {
    "id": "tarot-software",
    "slug": {
      "en": "tarot-software",
      "es": "software-de-tarot",
      "nl": "tarot-software",
      "pap": "software-di-tarot"
    },
    "title": {
      "en": "Tarot Software",
      "es": "Software de Tarot",
      "nl": "Tarot Software",
      "pap": "Tarot Software"
    },
    "category": "software",
    "status": "coming-soon",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "shortDescription": {
      "en": "A coming-soon TGWE study tool for Tarot as an initiatic system.",
      "es": "Una próxima herramienta de estudio de TGWE para el Tarot como sistema iniciático.",
      "nl": "Een binnenkort beschikbare TGWE-studietool voor Tarot als initiatisch systeem.",
      "pap": "Un hèrmènt di estudio di TGWE ku ta bin pronto pa Tarot komo sistema inisiátiko."
    },
    "description": {
      "en": "This item is not available to open yet. It is shown here as coming soon.",
      "es": "Este elemento aún no se puede abrir. Se muestra aquí como próximamente.",
      "nl": "Dit item kan nog niet worden geopend. Het wordt hier getoond als binnenkort beschikbaar.",
      "pap": "E artíkulo aki no por wòrdu habrí ainda. E ta wòrdu mustrá akinan komo pronto disponibel."
    },
    "useContext": {
      "en": "Supports symbolic study only when the student is prepared to interpret Tarot as a structured initiatic language rather than entertainment.",
      "es": "Apoya el estudio simbólico solo cuando el estudiante está preparado para interpretar el Tarot como un lenguaje iniciático estructurado y no como entretenimiento.",
      "nl": "Ondersteunt symbolische studie alleen wanneer de student bereid is Tarot te lezen als een gestructureerde initiatische taal in plaats van vermaak.",
      "pap": "Ta sostené estudio simbóliko solamente ora e studiante ta prepará pa interpretá Tarot komo un idioma inisiátiko strukturá i no komo entretenimentu."
    },
    "image": null,
    "imageAlt": null,
    "version": null,
    "releaseDate": null,
    "license": null,
    "builds": [],
    "faq": null,
    "relatedMediaSeasons": [
      "cycle-1-season-3",
      "cycle-1-season-4"
    ],
    "relatedCourses": [
      "tarot-great-work-practitioner",
      "tarot-great-work-master-training"
    ]
  },
  {
    "id": "nexus-framework",
    "slug": {
      "en": "nexus-framework",
      "es": "marco-nexus",
      "nl": "nexus-framework",
      "pap": "framework-nexus"
    },
    "title": {
      "en": "Nexus Framework",
      "es": "Marco Nexus",
      "nl": "Nexus Framework",
      "pap": "Nexus Framework"
    },
    "category": "framework",
    "status": "coming-soon",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "shortDescription": {
      "en": "A coming-soon TGWE framework tool for structured work.",
      "es": "Una próxima herramienta de marco de TGWE para el trabajo estructurado.",
      "nl": "Een binnenkort beschikbare TGWE-raamwerktool voor gestructureerd werk.",
      "pap": "Un hèrmènt di struktura di TGWE ku ta bin pronto pa trabou strukturá."
    },
    "description": {
      "en": "This item is not available to open yet. It is shown here as coming soon.",
      "es": "Este elemento aún no se puede abrir. Se muestra aquí como próximamente.",
      "nl": "Dit item kan nog niet worden geopend. Het wordt hier getoond als binnenkort beschikbaar.",
      "pap": "E artíkulo aki no por wòrdu habrí ainda. E ta wòrdu mustrá akinan komo pronto disponibel."
    },
    "useContext": {
      "en": "Organizes practice and content relationships without replacing direct perception, disciplined action, or canonical sequencing.",
      "es": "Organiza la práctica y las relaciones entre contenidos sin reemplazar la percepción directa, la acción disciplinada ni el orden canónico.",
      "nl": "Ordent de oefening en de samenhang tussen inhoud zonder directe waarneming, gedisciplineerd handelen of de canonieke volgorde te vervangen.",
      "pap": "Ta organisá práktika i e relashonnan di kontenido sin remplasá persepshon direkto, akshon disipliná, ni e òrden kanóniko."
    },
    "image": null,
    "imageAlt": null,
    "version": null,
    "releaseDate": null,
    "license": null,
    "builds": [],
    "faq": null,
    "relatedMediaSeasons": [],
    "relatedCourses": []
  },
  {
    "id": "nenadi",
    "slug": {
      "en": "nenadi",
      "es": "nenadi",
      "nl": "nenadi",
      "pap": "nenadi"
    },
    "title": {
      "en": "NeNadi",
      "es": "NeNadi",
      "nl": "NeNadi",
      "pap": "NeNadi"
    },
    "category": "tool",
    "status": "coming-soon",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "shortDescription": {
      "en": "A coming-soon content-streaming tool.",
      "es": "Una próxima herramienta de transmisión de contenido.",
      "nl": "Een binnenkort beschikbare tool voor het streamen van content.",
      "pap": "Un hèrmènt di streaming di kontenido ku ta bin pronto."
    },
    "description": {
      "en": "This item is not available to open yet. It is shown here as coming soon.",
      "es": "Este elemento aún no se puede abrir. Se muestra aquí como próximamente.",
      "nl": "Dit item kan nog niet worden geopend. Het wordt hier getoond als binnenkort beschikbaar.",
      "pap": "E artíkulo aki no por wòrdu habrí ainda. E ta wòrdu mustrá akinan komo pronto disponibel."
    },
    "useContext": {
      "en": "Serves access to material while remaining subordinate to the Work itself.",
      "es": "Brinda acceso al material sin dejar de estar subordinado a la Obra misma.",
      "nl": "Biedt toegang tot het materiaal en blijft daarbij ondergeschikt aan het Werk zelf.",
      "pap": "Ta duna akseso na e material miéntras ta keda subordiná na e Obra mes."
    },
    "image": null,
    "imageAlt": null,
    "version": null,
    "releaseDate": null,
    "license": null,
    "builds": [],
    "faq": null,
    "relatedMediaSeasons": [],
    "relatedCourses": []
  }
];
